export const mobileBrandName = [
  { barndName: "All" },
  { barndName: "Apple" },
  { barndName: "Samsung" },
  { barndName: "OnePlus" },
  { barndName: "Xiaomi" },
  { barndName: "Realme" },
  { barndName: "OPPO" },
  { barndName: "Vivo" },
  { barndName: "boAt" },
  { barndName: "Fire-Boltt" },
  { barndName: "Amazfit" },
  { barndName: "Noise" },
  { barndName: "Honor" },
  { barndName: "Google" },
  { barndName: "Nokia" },
  { barndName: "Asus" },
  { barndName: "LG" },
  { barndName: "Motorola" },
];

export const model = [
  {
    Name: "Samsung Galaxy S23 Ultra 5G",
    Price: "₹69,390",
    Data: "Feb 09, 2023",
    barndName: "Samsung",
  },
  {
    Name: "Samsung Galaxy F04",
    Price: "₹7,499",
    Data: "Jan 04, 2023",
    barndName: "Samsung",
  },
  {
    Name: "Samsung Galaxy A54 5G",
    Price: "₹24,999",
    Data: "Feb 16, 2023",
    barndName: "Samsung",
  },
  {
    Name: "Samsung Galaxy M23",
    Price: "₹14,999",
    Data: "Jan 29, 2023",
    barndName: "Samsung",
  },
  {
    Name: "Samsung Galaxy F44",
    Price: "₹11990",
    Data: "Jan 26, 2023",
    barndName: "Samsung",
  },
  {
    Name: "Samsung Galaxy S23 Plus 5G",
    Price: "₹82,890",
    Data: "Feb 01, 2023",
    barndName: "Samsung",
  },
  {
    Name: "Samsung Galaxy F32",
    Price: "₹18,290",
    Data: "Feb 14, 2023",
    barndName: "Samsung",
  },
  {
    Name: "Samsung Galaxy A05",
    Price: "₹14,990",
    Data: "Jan 25, 2023",
    barndName: "Samsung",
  },
  //   Apple
  {
    id: 94,
    slug: "iphone-14-pro-max",
    Name: "iPhone 14 Pro Max",
    barndName: "Apple",
  },
  {
    id: 95,
    slug: "iphone-14-pro",
    Name: "iPhone 14 Pro",
    barndName: "Apple",
  },
  {
    id: 96,
    slug: "iphone-14-plus",
    Name: "iPhone 14 Plus",
    barndName: "Apple",
  },
  {
    id: 97,
    slug: "iphone-14",
    Name: "iPhone 14",
    barndName: "Apple",
  },
  {
    id: 80,
    slug: "iphone-13",
    Name: "iPhone 13",
    barndName: "Apple",
  },
  {
    id: 81,
    slug: "iphone-13-mini",
    Name: "iPhone 13 mini",
    barndName: "Apple",
  },
  {
    id: 45,
    slug: "iphone-12",
    Name: "iPhone 12",
    barndName: "Apple",
  },
  {
    id: 13,
    slug: "iphone-11",
    Name: "iPhone 11",
    barndName: "Apple",
  },
  {
    id: 98,
    slug: "apple-watch-series-8",
    Name: "Apple Watch Series 8",
    barndName: "Apple",
  },
  {
    id: 99,
    slug: "apple-watch-se-2nd-generation",
    Name: "Apple Watch SE (2nd generation)",
    barndName: "Apple",
  },
  {
    id: 100,
    slug: "apple-watch-ultra",
    Name: "Apple Watch Ultra",
    barndName: "Apple",
  },
  //   Xiaomi
  {
    Name: "Xiaomi 13",
    Price: "Rs. 47,390",
    Data: "1st Apr 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi Redmi K60",
    Price: "Rs. 29,790",
    Data: "5th Apr 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Redmi Note 12 Pro Speed Edition",
    Price: "Rs. 20,290",
    Data: "23rd Mar 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi 12T Pro 5G",
    Price: "Rs. 60,490",
    Data: "18th Mar 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi 13 Lite 5G",
    Price: "Rs. 43,790",
    Data: "1st Apr 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi Redmi K60 Pro 5G",
    Price: "Rs. 39,290",
    Data: "12th Apr 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi Redmi 12C",
    Price: "Rs. 8,390",
    Data: "11th Apr 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi 12S Ultra",
    Price: "Rs. 70,690",
    Data: "31st Mar 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi 12T",
    Price: "Rs. 48,390",
    Data: "21st Mar 2023",
    barndName: "Xiaomi",
  },
  {
    Name: "Xiaomi Redmi K60E",
    Price: "Rs. 26,190",
    Data: "12th Apr 2023",
    barndName: "Xiaomi",
  },
  // ONePlus
  {
    Name: "OnePlus Ace 2V",
    Price: "Rs. 27,190",
    Data: "19th Jul 2023",
    barndName: "OnePlus",
  },
  {
    Name: "OnePlus Nord 3 5G",
    Price: "Rs. 27,999",
    Data: "21st Jun 2023",
    barndName: "OnePlus",
  },
  {
    Name: "OnePlus 11 Pro",
    Price: "Rs. 50,990",
    Data: "25th May 2023",
    barndName: "OnePlus",
  },
  {
    Name: "OnePlus Nord CE 3 5G",
    Price: "Rs. 24,999",
    Data: "19th Jul 2023",
    barndName: "OnePlus",
  },
  {
    Name: "OnePlus Nord 3 CE",
    Price: "Rs. 28,990",
    Data: "19th Apr 2023",
    barndName: "OnePlus",
  },
  //   RealME
  {
    Name: "realme GT Neo 5 5G",
    Price: "Rs. 31,690",
    Data: "9th May 2023",
    barndName: "Realme",
  },
  {
    Name: "realme 10s 5G",
    Price: "Rs. 13,090",
    barndName: "Realme",
    Data: "3rd Apr 2023",
  },
  {
    Name: "realme C55",
    Price: "Rs. 13,390",
    barndName: "Realme",
    Data: "21st Mar 2023",
  },
  {
    Name: "realme GT 3 5G",
    Price: "Rs. 53,690",
    barndName: "Realme",
    Data: "1st Aug 2023",
  },
  {
    Name: "realme 10 5G",
    Price: "Rs. 14,790",
    barndName: "Realme",
    Data: "17th May 2023",
  },
  {
    Name: "realme V30",
    Price: "Rs. 13,499",
    barndName: "Realme",
    Data: "12th Apr 2023",
  },
  {
    Name: "realme V23i 5G",
    Price: "Rs. 23,790",
    barndName: "Realme",
    Data: "2nd Apr 2023",
  },
  {
    Name: "realme 11 Pro",
    Price: "Rs. 39,990",
    barndName: "Realme",
    Data: "12th Apr 2023",
  },
  {
    Name: "realme Q6 Pro 5G",
    Price: "Rs. 15,990",
    barndName: "Realme",
    Data: "16th Mar 2023",
  },
  {
    Name: "realme GT Neo 5T",
    barndName: "Realme",
    Price: "Rs. 24,990",
  },
];

export const budgets = [
  { value: 10000 },
  { value: 15000 },
  { value: 20000 },
  { value: 25000 },
  { value: 30000 },
  { value: 35000 },
  { value: 40000 },
  { value: 45000 },
  { value: 50000 },
  { value: 55000 },
  { value: 60000 },
  { value: 70000 },
  { value: 80000 },
  { value: 100000 },
  { value: 150000 },
  { value: "Above 1.5 Lakh" },
];
export const gadgetTypes = [
  {
    value: "All",
  },
  {
    value: "Mobiles",
  },
  {
    value: "Laptops",
  },
  {
    value: "Smart Watches",
  },
   {
    value: "Drone",
  },
];
